import { EquipeSelectModel, UnidadeSaudeSelectModel } from 'components/form'
import { DseiSelectFieldModel } from 'components/form/field/select/DseiSelectField'
import { PoloBaseSelectFieldModel } from 'components/form/field/select/PoloBaseSelectField'
import { TipoEnderecoEnum } from 'graphql/types.generated'
import { isHyphen } from 'util/string/string-emptyOrHyphen'
import { cep, composeRules, createValidator, ErrorObject, maxLength, msg, required, RuleMap } from 'util/validation'

import { LogradouroEditFormModel, TerritorioViewTabEnum } from './model'

interface ValidacaoTerritorialFormFields {
  unidadeSaude?: UnidadeSaudeSelectModel
  equipe?: EquipeSelectModel
  tipoEndereco?: TipoEnderecoEnum
  cep?: string
  dsei?: DseiSelectFieldModel
  poloBase?: PoloBaseSelectFieldModel
}

export const validateVisualizacaoTerritorialForm = <T extends ValidacaoTerritorialFormFields>(
  tabContext: TerritorioViewTabEnum
) =>
  createValidator<T>(
    {
      tipoEndereco: tabContext === TerritorioViewTabEnum.LISTA_DE_IMOVEIS ? [required] : [],
      equipe: [required],
      unidadeSaude: [required],
    } as RuleMap<T>,
    (value, errors): ErrorObject<T> => {
      if (tabContext === TerritorioViewTabEnum.LISTA_DE_IMOVEIS) {
        if (TipoEnderecoEnum.LOGRADOURO === value.tipoEndereco) {
          errors.cep = composeRules([...cep])(value.cep)
        } else {
          errors.dsei = required(value.dsei)
          errors.poloBase = required(value.poloBase)
        }
      }

      return errors
    }
  )

export const validateLogradouroEditForm = () =>
  createValidator<LogradouroEditFormModel>(
    {
      cep: [required, cep],
      logradouro: [required, maxLength(72), validateEnderecoNaoInformado],
      tipoLogradouro: [required],
    },
    (value, errors): ErrorObject<LogradouroEditFormModel> => {
      errors.bairro = composeRules([required, maxLength(72), validateEnderecoNaoInformado])(value.bairro?.nome)
      return errors
    }
  )

const validateEnderecoNaoInformado = (value?: string) => {
  if (isHyphen(value)) {
    return msg('invalid', value)
  }
}
